/**
 * @desc 根据id获取供应商详情
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.ResponseDto<defs.srm.SupplierInfoResponseDto>;
export function request(id: number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierInfo/${id}`, {
      method: "GET",

      ...options,
    }),
  );
}
